<template>
  <div class="nebPanel" :style="computedStyle">
    <div class="nebPanel-title" v-if="hasTitle || hasControls">
      <div class="nebPanel-title-title">
        <div v-show="hasTitle">
          <h4>{{ title }}</h4>
        </div>
        <div class="nebPanel-title-info" v-show="hasInfoText">
          <neb-tooltip :content="infoText">
            <neb-icon style="color:#9b9b9b;" name="info"></neb-icon>
          </neb-tooltip>
        </div>
      </div>
      <div class="nebPanel-title-controls">
        <slot name="controls"></slot>
      </div>
    </div>

    <div class="nebPanel-content">
      <div class="nebPanel-content-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { isNull, isEmpty } from 'lodash'
import NebIcon from '../../Icon'
import NebTooltip from '../../generic/Tooltip'

export default {
  name: 'Panel',

  components: {
    NebIcon,
    NebTooltip
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    infoText: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'initial'
    },
    height: {
      type: String,
      default: 'initial'
    }
  },

  computed: {
    hasTitle () {
      return !isNull(this.title) &&
        !isEmpty(this.title)
    },
    hasControls () {
      return !!this.$slots.controls
    },
    hasInfoText () {
      return !isNull(this.infoText) &&
        !isEmpty(this.infoText)
    },
    computedStyle () {
      return {
        height: this.height,
        width: this.width
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebPanel {
  box-sizing: border-box;
  overflow: hidden;
  border: solid 1px $light-grey-blue;
  background-color: $white;
  padding: 12px 15px;

  &-content {
    box-sizing: border-box;
    overflow: hidden;
    padding-top: 9.5px;
  }

  &-title {
    box-sizing: border-box;
    overflow: hidden;
    border-bottom: solid 1px $pinkish-grey;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 7.5px;

    &-info {
      margin-left: 5px;
    }

    &-title {
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      align-items: center;

      h4 {
        margin: 0;
        padding: 0;
        font-family: $defaultFont;
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: $slate-grey;
      }
    }
  }
}
</style>
